import { useSetRecoilState } from 'recoil'
import selfOrganizationAtom from '../selfOrganization.atom'
import { useCallback } from 'react'
import { IOrganization } from '@/pages/Organizations/organizations.types'

const useSetSelfOrganization = () => {
  const setState = useSetRecoilState(selfOrganizationAtom)

  return useCallback((organization: Omit<IOrganization, '_count'>) => {
    setState((prev) => ({ ...prev, organization }))
  }, [])
}

export default useSetSelfOrganization
